import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CircularProgress, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import { useStyles } from './styles';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axiosInstance from '../../../environment/axiosInstance';
import { useHistory, useParams } from "react-router-dom";
import { decode } from 'html-entities';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

function EditArticle(props) {
    const classes = useStyles();
    const history = useHistory();
    const [openExpand, setOpenExpand] = React.useState(true);
    const [title, setTitle] = useState("");
    const [title_error, setTitleError] = useState("");
    const [description, setDescription] = useState("");
    const [description_error, setDescriptionError] = useState("");
    const [departments, setDepartments] = useState([]);
    const [products, setProducts] = useState([]);
    const [selected_department, setSelectedDepartment] = useState();
    const [selected_product, setSelectedProduct] = useState();

    useEffect(() => {
        axiosInstance
            .get('/departments').then((res) => {
                if (res.status === 200) {
                    setDepartments(res.data.data);
                    // setSelectedDepartment(res.data.data[0]?.id);
                }

            }).catch((err) => {
                console.log("departments error ", err);
            });

        axiosInstance
            .get('/support/business_owner/product').then((res) => {
                if (res.status === 200) {
                    setProducts(res.data.Data);
                    // setSelectedProduct(res.data.data[0]?.id);
                }

            }).catch((err) => {
                console.log("products error : ", err);
            });

        axiosInstance.get('/support/business_owner/article/' + props.match.params.id).then((res) => {
            // console.log('desk', res)
            if (res.status === 200) {
                setTitle(res.data.Data?.title);
                setDescription(res.data.Data?.description);
                setSelectedDepartment(res.data.Data?.department);
                setSelectedProduct(res.data.Data?.product);
            }
        }).catch((err) => {
            console.log("get article error ", err);
        });
    }, []);

    const expandOpen = () => {
        setOpenExpand(!openExpand)
    }

    const handleValidation = () => {
        var isValid = true;

        if (!title) {
            setTitleError("*Title is required.");
            isValid = false;
        }
        else {
            setTitleError("");
        }

        if (!description) {
            setDescriptionError("*Description is required.");
            isValid = false;
        }
        else {
            setDescriptionError("");
        }

        return isValid;
    }

    const onFormSubmit = (e) => {
        e.preventDefault();

        if (handleValidation()) {
            axiosInstance
                .patch("support/business_owner/article/edit/" + props.match.params.id, {
                    title: title,
                    description: description,
                    department: selected_department,
                    product: selected_product
                })
                .then((res) => {
                    if (res.data.statusCode == 200) {
                        history.push("/dashboard/articles");
                        toast.success(res.data.message, {
                            position: toast.POSITION.TOP_RIGHT, autoClose: 1000
                        });
                    }
                    else {
                        console.log(res);
                    }
                });
        }
    }


    return (
        <div>
            <Card className={classes.card}>
                <Accordion expanded={openExpand}
                    onChange={expandOpen}>
                    <AccordionSummary
                        expandIcon={openExpand ? <FiMinusCircle color="#2645ad" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>Edit Article</Typography>
                    </AccordionSummary>
                    <Divider className={classes.divider} />
                    <div className={classes.cardBody}>
                        <form onSubmit={(e) => onFormSubmit(e)}>
                            <div className='row m-0'>
                                <div className={classes.centerCol}>
                                    <div className={classes.titleRow}>
                                        <label><b>Title:</b></label>
                                        <input
                                            type="text"
                                            className={classes.inputField}
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                        />
                                    </div>
                                    <p className='m-0 text-danger'>{title_error}</p>
                                    <br />
                                    <div className={classes.titleRow}>
                                        <label><b>Department:</b></label>
                                        <select
                                            onChange={(e) => setSelectedDepartment(e.target.value)}
                                            className={classes.selectDepartment}
                                            defaultValue={selected_department}
                                            value={selected_department}
                                        >
                                            {
                                                departments?.map(department => {
                                                    return (
                                                        <option value={department?.id}>{department?.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                    <br />
                                    <div className={classes.titleRow}>
                                        <label><b>Product:</b></label>
                                        <select
                                            onChange={(e) => setSelectedProduct(e.target.value)}
                                            className={classes.selectDepartment}
                                            defaultValue={selected_product}
                                            value={selected_product}
                                        >
                                            {
                                                products?.map(product => {
                                                    return (
                                                        <>
                                                            {
                                                                product._id == selected_product ?
                                                                    <option value={product?._id} selected>{product?.name}</option>
                                                                    :
                                                                    <option value={product?._id}>{product?.name}</option>
                                                            }
                                                        </>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className='col-12' style={{
                                    marginTop: "20px"
                                }}>
                                    <label><b>Description:</b></label>
                                    <ReactQuill
                                        value={decode(description)}
                                        onChange={(value) => setDescription(value)}
                                        className={classes.Quill}
                                    />
                                    {/* <div className={classes.myEditingArea}></div> */}
                                    {/* </ReactQuill> */}
                                    <p className='m-0 text-danger' style={{
                                        marginTop: "45px"
                                    }}>{description_error}</p>
                                </div>
                                <div className='col-12 text-center'>
                                    <br /><br />
                                    <input type='submit' className={'btn ' + classes.submitBtn} />
                                </div>
                            </div>
                        </form>
                    </div>
                </Accordion>
            </Card>
        </div>
    )
}

export default EditArticle